import { NMIConfiguraton } from '../types/nmi'
import { ApplicationInsightsConfiguration } from '../types/applicationInsights'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const config = (window as any).config
export const nmiConfig: NMIConfiguraton = config.nmi
export const appInsightsConfig: ApplicationInsightsConfiguration = config.applicationInsights
